import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SystemSettingsStore } from '../../core/services/system-settings.store';
import { getLogoHeight } from '../../core/services/theme.model';

@Component({
  selector: 'app-logo',
  imports: [RouterLink],
  host: { class: 'block min-w-0 max-w-full' },
  template: `
    @if (systemSettingsStore.branding()?.light || systemSettingsStore.branding()?.dark) {
      @if (linkToDashboard()) {
        <a routerLink="/dashboard" aria-label="Naar dashboard" data-cy="logo-link" class="block">
          <img
            class="w-auto max-w-full shrink-0 object-contain only-light-theme"
            data-cy="logo"
            alt="logo"
            [style.height.px]="logoHeight()"
            [src]="systemSettingsStore.branding()?.light?.logo?.blobUrl" />
          <img
            class="w-auto max-w-full shrink-0 object-contain only-dark-theme"
            data-cy="logo"
            alt="logo"
            [style.height.px]="logoHeight()"
            [src]="systemSettingsStore.branding()?.dark?.logo?.blobUrl" />
        </a>
      } @else {
        <img
          class="w-auto max-w-full shrink-0 object-contain only-light-theme"
          data-cy="logo"
          alt="logo"
          [style.height.px]="logoHeight()"
          [src]="systemSettingsStore.branding()?.light?.logo?.blobUrl" />
        <img
          class="w-auto max-w-full shrink-0 object-contain only-dark-theme"
          data-cy="logo"
          alt="logo"
          [style.height.px]="logoHeight()"
          [src]="systemSettingsStore.branding()?.dark?.logo?.blobUrl" />
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    /* Logo-as-link is otherwise visually identical to the plain logo — only cursor:pointer
       (default anchor behavior) changes. Focus ring follows the same idiom as
       link-button.component.ts and upload-dropzone: the base layer kills the UA outline
       globally ("* { &:focus { outline: none !important } }" in tailwind.scss), so this
       keyboard-reachable link needs its own ring via --dd-btn-focus-inner/-outer. */
    a[data-cy='logo-link']:focus-visible {
      outline: none !important;
      box-shadow:
        0 0 0 2px var(--dd-btn-focus-inner),
        0 0 0 4px var(--dd-btn-focus-outer) !important;
    }
  `,
})
export class LogoComponent {
  readonly systemSettingsStore = inject(SystemSettingsStore);
  readonly logoHeight = computed(() => getLogoHeight(this.systemSettingsStore.branding()));

  /** Wraps the logo in a link to `/dashboard`. Public pages (home, sign-out) opt out. */
  readonly linkToDashboard = input(true);
}
